import { render, staticRenderFns } from "./AdminEdicionRegistro.vue?vue&type=template&id=590084c4&"
import script from "./AdminEdicionRegistro.vue?vue&type=script&lang=js&"
export * from "./AdminEdicionRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports